import { render, staticRenderFns } from "./TransfersList.vue?vue&type=template&id=979dfbd2&"
import script from "./TransfersList.vue?vue&type=script&lang=js&"
export * from "./TransfersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports